// External Imports
import { createSelector } from 'reselect';

// Internal Imports
import { getActiveContentItem } from './getActiveContentItem.js';

// Local Functions
const getIsActiveLoading = (state) => state.active.loading.content;

const getIsActiveContentItemLoading = createSelector(
  [getActiveContentItem, getIsActiveLoading],
  (activeContentItem, loading) => (loading && !activeContentItem) || !activeContentItem,
);

const getIsActiveContentItemLoadingRelated = createSelector(
  [getActiveContentItem, getIsActiveLoading],
  (activeContentItem, activeLoading) => activeContentItem && activeLoading,
);

// Module Exports
export { getIsActiveContentItemLoading, getIsActiveContentItemLoadingRelated };
